"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompareFunction = exports.sortOptions = void 0;
function sortOptions(options, sort) {
    if (!sort) {
        return options;
    }
    const compareFunction = getCompareFunction(sort);
    options.sort(compareFunction);
    return options;
}
exports.sortOptions = sortOptions;
function getCompareFunction(sort) {
    return (a, b) => {
        const textA = a.text.toLowerCase();
        const textB = b.text.toLowerCase();
        if (textA < textB) {
            return sort === 'asc' ? -1 : 1;
        }
        if (textA > textB) {
            return sort === 'asc' ? 1 : -1;
        }
        return 0;
    };
}
exports.getCompareFunction = getCompareFunction;
//# sourceMappingURL=sortOptions.js.map